module.exports = __webpack_public_path__ + "img/homepage.0ab6f918.jpg";